export enum LOCAL_STORAGE_KEY {
  I18N_LNG = "SMELTS_I18N_LNG",
  ACCESS_TOKEN = "SMELTS_ACCESS_TOKEN",
  LAST_ACTION = "SMELTS_LAST_ACTION",
  DISMISSED_EXPLANATIONS = "SMELTS_DISMISSED_EXPLANATIONS",
}
